var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"r-list-header"},[_vm._t("default")],2),_c('r-hr',{attrs:{"hrStyle":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }